import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "portaria-panel" }
const _hoisted_2 = { class: "portaria-tabs" }
const _hoisted_3 = {
  key: 0,
  class: "portaria-tab-badge"
}
const _hoisted_4 = {
  key: 0,
  class: "portaria-tab-badge"
}
const _hoisted_5 = { class: "portaria-body" }
const _hoisted_6 = {
  key: 0,
  class: "portaria-section"
}
const _hoisted_7 = { class: "portaria-form" }
const _hoisted_8 = {
  key: 0,
  class: "portaria-field portaria-field-wide"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "portaria-grid" }
const _hoisted_11 = { class: "portaria-field" }
const _hoisted_12 = { class: "portaria-field" }
const _hoisted_13 = { class: "portaria-field" }
const _hoisted_14 = { class: "portaria-field" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "portaria-field" }
const _hoisted_17 = { class: "portaria-field" }
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 1,
  class: "portaria-error"
}
const _hoisted_20 = { class: "portaria-actions" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "portaria-loading"
}
const _hoisted_23 = {
  key: 1,
  class: "portaria-empty"
}
const _hoisted_24 = {
  key: 2,
  class: "portaria-list"
}
const _hoisted_25 = { class: "portaria-item-main" }
const _hoisted_26 = { class: "portaria-item-title" }
const _hoisted_27 = { class: "portaria-item-meta" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "portaria-section"
}
const _hoisted_31 = { class: "portaria-form" }
const _hoisted_32 = { class: "portaria-grid" }
const _hoisted_33 = { class: "portaria-field" }
const _hoisted_34 = { class: "portaria-field" }
const _hoisted_35 = { class: "portaria-field" }
const _hoisted_36 = { class: "portaria-field" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "portaria-field" }
const _hoisted_39 = { class: "portaria-field" }
const _hoisted_40 = {
  key: 0,
  class: "portaria-error"
}
const _hoisted_41 = { class: "portaria-actions" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 0,
  class: "portaria-empty"
}
const _hoisted_44 = {
  key: 1,
  class: "portaria-list"
}
const _hoisted_45 = { class: "portaria-item-main" }
const _hoisted_46 = { class: "portaria-item-title" }
const _hoisted_47 = { class: "portaria-item-meta" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 2,
  class: "portaria-section"
}
const _hoisted_51 = { class: "portaria-filters" }
const _hoisted_52 = { class: "portaria-field" }
const _hoisted_53 = { class: "portaria-field" }
const _hoisted_54 = { class: "portaria-field portaria-field-actions" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 0,
  class: "portaria-loading"
}
const _hoisted_58 = {
  key: 1,
  class: "portaria-empty"
}
const _hoisted_59 = {
  key: 2,
  class: "portaria-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "portaria-header" }, [
      _createElementVNode("h2", { class: "portaria-title" }, "Portaria"),
      _createElementVNode("p", { class: "portaria-subtitle" }, "Liberação e registro de entrada e saída de pessoas na obra.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["portaria-tab", { active: _ctx.activeTab === 'portao' }]),
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'portao'))
      }, [
        _cache[23] || (_cache[23] = _createTextVNode(" Portão ", -1)),
        (_ctx.insideCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.insideCount), 1))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.accessLevel >= 2)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["portaria-tab", { active: _ctx.activeTab === 'liberacoes' }]),
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'liberacoes'))
          }, [
            _cache[24] || (_cache[24] = _createTextVNode(" Liberações ", -1)),
            (_ctx.pendingReleases.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.pendingReleases.length), 1))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.accessLevel >= 3)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(["portaria-tab", { active: _ctx.activeTab === 'historico' }]),
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'historico'))
          }, "Histórico", 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.activeTab === 'portao')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "portaria-section-label" }, "Registrar entrada", -1)),
              (_ctx.pendingReleases.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", { class: "portaria-label" }, "Confirmar visitante esperado", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "portaria-select",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedReleaseId) = $event)),
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyRelease && _ctx.applyRelease(...args)))
                    }, [
                      _cache[25] || (_cache[25] = _createElementVNode("option", { value: "" }, "— Visitante não esperado —", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingReleases, (r) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: r.id,
                          value: r.id
                        }, _toDisplayString(r.name) + " — " + _toDisplayString(r.company || r.reason), 9, _hoisted_9))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.selectedReleaseId]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "portaria-label" }, "Nome", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "portaria-input",
                    type: "text",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.entryForm.name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.entryForm.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "portaria-label" }, "Documento", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "portaria-input",
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.entryForm.document) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.entryForm.document]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "portaria-label" }, "Empresa / Motivo", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "portaria-input",
                    type: "text",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.entryForm.company) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.entryForm.company]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "portaria-label" }, "Responsável na obra", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "portaria-select",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.entryForm.hostUserId) = $event))
                  }, [
                    _cache[30] || (_cache[30] = _createElementVNode("option", { value: "" }, "— Selecione —", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOptions, (u) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: u.username,
                        value: u.username
                      }, _toDisplayString(u.name), 9, _hoisted_15))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.entryForm.hostUserId]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { class: "portaria-label" }, "Veículo / Placa (opcional)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "portaria-input",
                    type: "text",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.entryForm.vehiclePlate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.entryForm.vehiclePlate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "portaria-label" }, "Obra (opcional)", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "portaria-select",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.entryForm.projectId) = $event))
                  }, [
                    _cache[33] || (_cache[33] = _createElementVNode("option", { value: "" }, "— Não especificado —", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: p.id,
                        value: p.id
                      }, _toDisplayString(p.name), 9, _hoisted_18))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.entryForm.projectId]
                  ])
                ])
              ]),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "portaria-btn portaria-btn-primary",
                  type: "button",
                  disabled: _ctx.saving,
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.submitEntry && _ctx.submitEntry(...args)))
                }, _toDisplayString(_ctx.saving ? 'Registrando...' : 'Registrar entrada'), 9, _hoisted_21)
              ])
            ]),
            _cache[36] || (_cache[36] = _createElementVNode("div", {
              class: "portaria-section-label",
              style: {"margin-top":"20px"}
            }, "Dentro da obra agora", -1)),
            (_ctx.loadingEntries)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Carregando..."))
              : (_ctx.insideEntries.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Ninguém registrado no momento."))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insideEntries, (e) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: e.id,
                        class: "portaria-item"
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(e.name), 1),
                          _createElementVNode("div", _hoisted_27, [
                            _createTextVNode(_toDisplayString(e.company || e.reason || '—') + " ", 1),
                            (e.projectName)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, " · " + _toDisplayString(e.projectName), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, " · entrou às " + _toDisplayString(_ctx.formatTime(e.entryAt)), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "portaria-btn portaria-btn-danger",
                          type: "button",
                          onClick: ($event: any) => (_ctx.exit(e.id))
                        }, "Registrar saída", 8, _hoisted_29)
                      ]))
                    }), 128))
                  ]))
          ]))
        : (_ctx.activeTab === 'liberacoes')
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "portaria-section-label" }, "Nova liberação prévia", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "portaria-label" }, "Nome", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "portaria-input",
                      type: "text",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.releaseForm.name) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.releaseForm.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "portaria-label" }, "Documento", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "portaria-input",
                      type: "text",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.releaseForm.document) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.releaseForm.document]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", { class: "portaria-label" }, "Empresa / Motivo", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "portaria-input",
                      type: "text",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.releaseForm.company) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.releaseForm.company]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _cache[41] || (_cache[41] = _createElementVNode("label", { class: "portaria-label" }, "Responsável na obra", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "portaria-select",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.releaseForm.hostUserId) = $event))
                    }, [
                      _cache[40] || (_cache[40] = _createElementVNode("option", { value: "" }, "— Selecione —", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOptions, (u) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: u.username,
                          value: u.username
                        }, _toDisplayString(u.name), 9, _hoisted_37))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.releaseForm.hostUserId]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", { class: "portaria-label" }, "Veículo / Placa (opcional)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "portaria-input",
                      type: "text",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.releaseForm.vehiclePlate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.releaseForm.vehiclePlate]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _cache[43] || (_cache[43] = _createElementVNode("label", { class: "portaria-label" }, "Previsto para", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "portaria-input",
                      type: "datetime-local",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.releaseForm.expectedAt) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.releaseForm.expectedAt]
                    ])
                  ])
                ]),
                (_ctx.releaseError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.releaseError), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("button", {
                    class: "portaria-btn portaria-btn-primary",
                    type: "button",
                    disabled: _ctx.savingRelease,
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.submitRelease && _ctx.submitRelease(...args)))
                  }, _toDisplayString(_ctx.savingRelease ? 'Liberando...' : 'Liberar visitante'), 9, _hoisted_42)
                ])
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("div", {
                class: "portaria-section-label",
                style: {"margin-top":"20px"}
              }, "Visitantes aguardados", -1)),
              (_ctx.pendingReleases.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Nenhuma liberação pendente."))
                : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingReleases, (r) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: r.id,
                        class: "portaria-item"
                      }, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, _toDisplayString(r.name), 1),
                          _createElementVNode("div", _hoisted_47, [
                            _createTextVNode(_toDisplayString(r.company || r.reason || '—') + " ", 1),
                            (r.expectedAt)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_48, " · previsto " + _toDisplayString(_ctx.formatDateTime(r.expectedAt)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "portaria-btn",
                          type: "button",
                          onClick: ($event: any) => (_ctx.cancel(r.id))
                        }, "Cancelar", 8, _hoisted_49)
                      ]))
                    }), 128))
                  ]))
            ]))
          : (_ctx.activeTab === 'historico')
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _cache[46] || (_cache[46] = _createElementVNode("label", { class: "portaria-label" }, "De", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "portaria-input",
                      type: "date",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.historyFilters.dateFrom) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.historyFilters.dateFrom]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", { class: "portaria-label" }, "Até", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "portaria-input",
                      type: "date",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.historyFilters.dateTo) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.historyFilters.dateTo]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("button", {
                      class: "portaria-btn",
                      type: "button",
                      disabled: _ctx.loadingHistory,
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.loadHistory && _ctx.loadHistory(...args)))
                    }, _toDisplayString(_ctx.loadingHistory ? 'Buscando...' : 'Buscar'), 9, _hoisted_55),
                    _createElementVNode("button", {
                      class: "portaria-btn portaria-btn-primary",
                      type: "button",
                      disabled: _ctx.loadingHistory || _ctx.historyRows.length === 0,
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.exportHistory && _ctx.exportHistory(...args)))
                    }, "Exportar Excel", 8, _hoisted_56)
                  ])
                ]),
                (_ctx.loadingHistory)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Carregando..."))
                  : (_ctx.historyRows.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, "Nenhum registro encontrado."))
                    : (_openBlock(), _createElementBlock("table", _hoisted_59, [
                        _cache[48] || (_cache[48] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Nome"),
                            _createElementVNode("th", null, "Empresa / Motivo"),
                            _createElementVNode("th", null, "Obra"),
                            _createElementVNode("th", null, "Entrada"),
                            _createElementVNode("th", null, "Saída"),
                            _createElementVNode("th", null, "Registrado por")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyRows, (r) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: r.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(r.name), 1),
                              _createElementVNode("td", null, _toDisplayString(r.company || r.reason || '—'), 1),
                              _createElementVNode("td", null, _toDisplayString(r.projectName || '—'), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDateTime(r.entryAt)), 1),
                              _createElementVNode("td", null, _toDisplayString(r.exitAt ? _ctx.formatDateTime(r.exitAt) : '—'), 1),
                              _createElementVNode("td", null, _toDisplayString(r.registeredByName), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}